module.exports = {"id":null,"no_dok":0,"nomor_lengkap":null,"tgl_dok":null,"nama_pejabat":null,"nip_pejabat":null,"keterangan":null,"is_locked":false}


//////////////////
// WEBPACK FOOTER
// ./src/defaults/defaultPembatalan.json
// module id = T769
// module chunks = 1